import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import "./style.scss";

export const TripModal = ({
  isModalOpen,
  toggleModal,
  buttonText,
  closeText = "Close",
  title,
  tripText,
  size = "md",
  loading = false,
  showButtons = true,
  showEditIcon = false,
  showDeleteIcon = false,
  showcloseIcon = false,
  onSubmit = () => { },
  editIconClick = () => { },
  deleteIconClick = () => { },
  children,
  isRealTime = false,
}) => {
  return (
    <Modal
      fade={true}
      isOpen={isModalOpen}
      toggle={toggleModal}
      centered
      size={size}
      className={`tripModal ${isRealTime ? "realTimeTripModal" : ""}`}

    >
      <ModalHeader className="tripModalHeader custom-box">
        <div className="d-flex flex-column gap-1 ">
          <p className="tripTitle">{title}</p>
          <span className="tripText">{tripText}</span>
        </div>

        <div className="d-flex gap-2">
          {showEditIcon && (
            <i
              onClick={editIconClick}
              className="ri-pencil-fill cursor-pointer"
              style={{ color: "#0F62FE", fontSize: "20px" }}
            />
          )}

          {showDeleteIcon && (
            <i
              onClick={deleteIconClick}
              className="ri-delete-bin-fill cursor-pointer"
              style={{ color: "#FB0000", fontSize: "20px" }}
            />
          )}

          {showcloseIcon && (
            <i
              onClick={toggleModal}
              className="ri-close-fill cursor-pointer"
              style={{ color: "black", fontSize: "24px" }}
            />
          )}
        </div>
      </ModalHeader>

      <ModalBody className="tripModalBody">{children}</ModalBody>
      <ModalFooter className="w-100 p-0">
        {showButtons && (
          <div className="col-12 d-flex m-0">
            <div className="col-6">
              <Button className="updateProfileClose" onClick={toggleModal}>
                {closeText}
              </Button>
            </div>
            <div className="col-6">
              <Button
                disabled={loading}
                className="updateProfile"
                onClick={onSubmit}
              >
                {loading ? <Spinner /> : buttonText}
              </Button>
            </div>
          </div>
        )}
      </ModalFooter>
    </Modal>
  );
};
